import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export let API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Self-healing base URL: if the configured backend URL is unreachable (e.g. a
// deployment where REACT_APP_BACKEND_URL points at a subdomain without SSL),
// fall back to the same origin that served the app, where /api is always routed.
// This only triggers on a network error (no HTTP response), so a correctly
// configured environment (preview/prod) is never affected.
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const cfg = error.config;
    // Only genuine "backend unreachable" network errors (not timeouts/cancels).
    if (error.code === "ERR_NETWORK" && cfg && !cfg.__triedSameOrigin) {
      cfg.__triedSameOrigin = true;
      cfg.baseURL = "/api";
      const res = await api.request(cfg); // if this also fails, it rejects
      api.defaults.baseURL = "/api"; // switch permanently only after success
      return res;
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
